module.exports = __webpack_public_path__ + "static/media/Nazca.411e70be.png";